import { GUEST_ERROR_MESSAGES, checkBookerDomain } from '@repo/lib';
import {
  bookerEmailOf,
  checkoutBookerDomainRule,
  checkoutGuestSettings,
  currentGuestRows,
  pendingGuestIndex,
} from './checkoutGuests';

/** An attendee open or typed into and not saved stops Pay, which would send their last saved details. */
export default function checkGuestsBeforePay(checkout, form) {
  const settings = checkoutGuestSettings(checkout);
  const bookerRule = checkoutBookerDomainRule(checkout);
  if (!bookerRule) return { ok: true };

  const booker = checkBookerDomain(bookerEmailOf(form.fields), bookerRule);
  const bookerProblem = booker.ok
    ? {}
    : {
        bookerFieldId: Object.values(form.fields ?? {}).find(field => field?.type === 'email')?._id,
        message: booker.message,
      };

  if (!settings) return booker.ok ? { ok: true } : { ok: false, ...bookerProblem };

  const rows = currentGuestRows(checkout, form);
  const pendingGuest = pendingGuestIndex(rows, form.guestPanel?.open ?? -1);
  if (pendingGuest !== -1) return { ok: false, pendingGuest, ...bookerProblem };
  if (!booker.ok) return { ok: false, ...bookerProblem };

  if (settings.requireAllBeforePayment) {
    const firstMissing = rows.findIndex(row => !row.done);
    if (firstMissing !== -1) {
      return { ok: false, openGuest: firstMissing, message: GUEST_ERROR_MESSAGES.everyGuest };
    }
  }

  return { ok: true };
}
